module.exports = __webpack_public_path__ + "static/hackthon-833612a6f9f684a7e8dda5d2363a6aae.svg";